module.exports = function () {

  var sharedOptions = {
    id: 'hviezda.sk',
    hostname: '/shared/'

  };
  var options = {
    letenky: {
      formType: 'round_trip'
    },
    ubytovani: {

    },
    airticketOffersWidget: {
      count: 10,
      component_id: 'hviezda.sk',
      set: 'default_sk'
    }
  };

  Object.keys(options).forEach((key) => {
    options[key] = $.extend({}, sharedOptions, options[key]);
  });

  return options;

};